import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { CustomizeApiService } from '../customize-api.service';

@Component({
  selector: 'app-exit-link',
  templateUrl: './exit-link.component.html',
  styleUrls: ['./exit-link.component.scss'],
})
export class ExitLinkComponent implements OnInit {
  exitLinkGroup: UntypedFormGroup;

  constructor(
    private customizeApi: CustomizeApiService,
    private formBuilder: UntypedFormBuilder,
    private snackbarService: SnackbarService,
    private translations: TranslateService,
  ) {}

  ngOnInit(): void {
    this.exitLinkGroup = this.formBuilder.group({
      linkText: '',
      customUrl: '',
      logoutUrl: '',
      selectedLink: 'default',
    });
  }

  save(): void {
    this.customizeApi
      .saveExitLink(
        this.exitLinkGroup.get(['linkText']).value,
        this.exitLinkGroup.get(['customUrl']).value,
        this.exitLinkGroup.get(['logoutUrl']).value,
        this.exitLinkGroup.get(['selectedLink']).value,
      )
      .subscribe(
        () => this.snackbarService.successSnack(this.translations.instant('CUSTOMIZE_PARTNER.EXIT_LINK.FORM_SUCCESS')),
        (err) => {
          console.error(err);
          this.snackbarService.errorSnack(this.translations.instant('CUSTOMIZE_PARTNER.EXIT_LINK.FORM_FAILURE'));
        },
      );
  }

  restoreDefault(): void {
    if (!confirm(this.translations.instant('CUSTOMIZE_PARTNER.SHARED.RESTORE_DEFAULT_CONFIRMATION'))) {
      return;
    }
  }
}
